import React, { FC } from 'react'
import './Button.scss'
import { ButtonVariantsEnum, IButton } from "src/components/Button/types"
import { getStyles } from "src/helpers"

const Button: FC<IButton> = (props) => {
    const {
        children,
        variant = ButtonVariantsEnum.PRIMARY,
        className,
        ...rest
    } = props

    const styles = getStyles("button", [variant], className)

    return (
        <button
            {...rest}
            className={styles}
        >
            {children}
        </button>
    )
}

export default Button